import { Button } from '@/shared/components/Button';
import { Modal } from '@/shared/components/Modal';
import styles from './ConfirmDialog.module.scss';

export interface ConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  /** Pergunta que **nomeia o objeto**: "Excluir o agendamento de terça, 14h?" */
  title: string;
  /** Consequencia, dita por extenso: "Não é possível desfazer." */
  description: string;
  /** Rotulo do botao de confirmacao. Repete o verbo do titulo. */
  confirmLabel?: string;
  cancelLabel?: string;
  /** Usa a variante destrutiva no botao de confirmacao. */
  destructive?: boolean;
  loading?: boolean;
}

/**
 * Confirmacao de acao.
 *
 * A regra e do design system e nao e negociavel: a confirmacao destrutiva
 * **nomeia o objeto e a consequencia**. "Tem certeza?" nao diz o que sera
 * apagado nem se da para voltar atras.
 */
export function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  destructive = false,
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      size="form"
      footer={
        <>
          <Button variant="tertiary" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className={styles.description}>{description}</p>
    </Modal>
  );
}
